import { getStoredAccessToken } from './tokenStorage';

function decodeBase64Url(value) {
  if (!value) {
    return null;
  }

  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');

  try {
    if (typeof atob === 'function') {
      return atob(padded);
    }

    return Buffer.from(padded, 'base64').toString('utf8');
  } catch (error) {
    return null;
  }
}

export function parseJwtClaims(token) {
  if (!token) {
    return null;
  }

  const segments = token.split('.');
  if (segments.length < 2) {
    return null;
  }

  const decodedPayload = decodeBase64Url(segments[1]);
  if (!decodedPayload) {
    return null;
  }

  try {
    return JSON.parse(decodedPayload);
  } catch (error) {
    return null;
  }
}

export function getStoredTokenClaims() {
  return parseJwtClaims(getStoredAccessToken());
}

export function getStoredSubscriptionClaims() {
  const claims = getStoredTokenClaims();
  if (!claims) {
    return null;
  }

  return {
    subscription_status: claims.subscription_status ?? null,
    subscription_tier: claims.subscription_tier ?? null,
    subscription_expiry_date: claims.subscription_expiry_date ?? null,
    entitlements: Array.isArray(claims.entitlements) ? claims.entitlements : null,
  };
}